import React from 'react';
import { addPlatformAlertActivity, getPlatformAlertActivityHistory, getPlatformAlertIncidentDetailForAnalyse } from '../../Api/PlatformAlertsApi';
import { PLATFORM_ALERT_RESOLVED_STATUSES } from './PlatformAlertConfigs';
import { buildPlatformConditionRows } from '../BmsFaults/SingleAlertAnalysis/viewConditionRows';
import { FEATURE_CODES } from '../../Static/FeatureMapping';
import IncidentActionDialog, { DEFAULT_ALERT_STATUS_OPTIONS } from '../Alerts/IncidentActionDialog';

// Smart Alerts (Platform Alerts V2) binding for the shared IncidentActionDialog. All
// platform-specific wiring (alerts/v2 activity API, alertInstructions checklist source,
// alert-shaped condition rows, PLATFORM_ALERTS_V2 permission) lives here; the dialog UI
// itself is domain-agnostic and shared with BMS Faults.
const PLATFORM_ACTION_CONFIG = {
    featureCode: FEATURE_CODES.PLATFORM_ALERTS_V2,
    api: {
        logActivity: addPlatformAlertActivity,
        getActivityHistory: getPlatformAlertActivityHistory,
        getInfo: getPlatformAlertIncidentDetailForAnalyse,
    },
    getInstructions: (d) => d?.alertInstructions ?? [],
    buildConditionRows: buildPlatformConditionRows,
    resolvedStatuses: PLATFORM_ALERT_RESOLVED_STATUSES,
    statusOptions: DEFAULT_ALERT_STATUS_OPTIONS,
    // Smart Alerts does not surface the severity level (LVx) anywhere.
    showLevel: false,
};

const PlatformAlertActionDialog = (props) => (
    <IncidentActionDialog {...props} config={PLATFORM_ACTION_CONFIG} />
);

export default PlatformAlertActionDialog;
